import { render, staticRenderFns } from "./PromotedList.vue?vue&type=template&id=5274b694"
import script from "./PromotedList.vue?vue&type=script&lang=js"
export * from "./PromotedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports